export const UPDATE_DATA = 'UPDATE_DATA'
export const UPDATE_SHOW_COUNT = 'UPDATE_SHOW_COUNT'
export const UPDATE_IS_SEARCHING = 'UPDATE_IS_SEARCHING'
